<!-- Responsive Vehicle Monitoring Dashboard (Screenshot-style UI) -->
<ds-loading *ngIf="showLdr"></ds-loading>
<div class="dashboard-top-bar">
    <div class=" align-items-md-center">
        <div class="row hdrBar">
            <div class="col-lg-12 col-md-12 mg-a">
                <h1 *ngIf="clntDtls && clntDtls.length > 0">
                    <app-common-header [header_name]="header_label"></app-common-header>
                </h1>
            </div>
        </div>
    </div>
    <div class="dashboard-top-controls">
        <div class="row">
            <div class="col-lg-4 col-md-4 dashboard-filter-col">
                <label class="dashboard-filter-label">Zone</label>
                <nz-select nzShowSearch class="dashboard-top-select" [(ngModel)]="selectedtenants"
                    (ngModelChange)="getWrds($event)" [ngModelOptions]="{standalone: true}">
                    <nz-option [nzLabel]="'Select All'" [nzValue]="0"></nz-option>
                    <nz-option *ngFor="let t of tntLst" [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
                </nz-select>
            </div>
            <div class="col-lg-3 col-md-3 dashboard-filter-col">
                <label class="dashboard-filter-label">Ward</label>
                <nz-select nzShowSearch class="dashboard-top-select" [(ngModel)]="selectedward"
                    (ngModelChange)="onWrdSelect($event)" [ngModelOptions]="{standalone: true}">
                    <nz-option [nzLabel]="'Select All'" [nzValue]="0"></nz-option>
                    <nz-option *ngFor="let w of wardLst" [nzValue]="w.wrd_id" [nzLabel]="w.wrd_nm"></nz-option>
                </nz-select>
            </div>
            <div class="col-lg-4 col-md-4 dashboard-filter-col alert-select-container">
                <label class="dashboard-filter-label">Alert</label>
                <div class="custom-select-badge-wrapper">
                    <nz-select nzShowSearch class="dashboard-top-select" [(ngModel)]="selectedalert"
                        (ngModelChange)="onAlertTypeSelect($event)" [ngModelOptions]="{ standalone: true }"
                        nzMode="multiple" [nzMaxTagCount]="1" [nzMaxTagPlaceholder]="customTagPlaceholder">
                        <nz-option *ngFor="let a of AlertTypeLst" [nzValue]="a.alert_cat_id"
                            [nzLabel]="a.alert_cat_nm"></nz-option>
                    </nz-select>
                    <!-- <span *ngIf="selectedalert?.length > 1" class="custom-alert-count-badge">
                        +{{ selectedalert.length - 1 }}
                    </span> -->
                </div>
            </div>
        </div>
        <div class="row Lst_rfrshd" style="text-align: right;     margin-top: 6px;">
            <div class="col-lg-12 col-md-12"><span style="color: #ab5d4a;font-weight: bold;"> {{curdate |
                    date:'dd-MM-yyyy'}}
                    {{refresh_tm}}
                </span>
            </div>
        </div>
    </div>
</div>
<!-- View Toggle Buttons Row (between filters and content) -->
<div class="view-toggle-bar">
    <button nz-button nzType="default" nzShape="round" (click)="toggleView('tables')" [disabled]="showTablesOnly">
        <i nz-icon nzType="table" nzTheme="outline"></i> Tables View
    </button>
    <button nz-button nzType="default" nzShape="round" (click)="toggleView('map')" [disabled]="showMapOnly">
        <i nz-icon nzType="environment" nzTheme="outline"></i> Map View
    </button>
    <button nz-button nzType="default" nzShape="round" (click)="toggleView('split')"
        [disabled]="!showMapOnly && !showTablesOnly">
        <i nz-icon nzType="appstore" nzTheme="outline"></i> Both Views
    </button>

</div>

<!-- Main Dashboard Views -->
<div class="dashboard-content" [ngClass]="{'tables-only': showTablesOnly, 'map-only': showMapOnly}">
    <div *ngIf="!showTablesOnly" class="map-view-col">
        <div class="map-section">
            <div class="map-header">
                <span class="section-title">Map View</span>
                <div class="map-controls-top-right">
                    <!-- <label nz-checkbox [(ngModel)]="showRegionBoundary" class="region-boundary-checkbox">
                        Show Region Boundary
                    </label> -->
                    <button nz-button nzType="primary" nzShape="round"
                        (click)="showMapIndicationPanel = !showMapIndicationPanel">
                        <i nz-icon nzType="appstore" nzTheme="outline"></i> Map Indication
                    </button>
                    <div class="map-indication-panel nz-card" *ngIf="showMapIndicationPanel">
                        <div class="legend-title"><i nz-icon nzType="appstore" nzTheme="outline"></i> Map Indication
                        </div>
                        <div class="legend-list">
                            <label *ngFor="let cat of alertCategories">
                                <input type="checkbox" [(ngModel)]="cat.visible" (change)="toggleCategory(cat)" />
                                <i nz-icon [nzType]="cat.icon" nzTheme="twoTone" [nzTwoToneColor]="cat.color"
                                    style="font-size:18px;"></i>
                                <span>{{cat.label}}</span>
                            </label>
                        </div>
                    </div>

                </div>
            </div>
            <div id="alertsMap">
                <div class="vhcl-sts-card">
                    <ul>
                        <li>
                            <span class="greenCls" style="height: 12px; width: 12px; "></span> Running
                        </li>
                        <li>
                            <span class="blueCls" style="height: 12px; width: 12px; "></span> Stationed for < 5Min </li>
                        <li>
                            <span class="yellowCls" style="height: 12px; width: 12px; "></span> Stationed for 5Min -
                            15Min
                        </li>
                        <li>
                            <span class="redCls" style="height: 12px; width: 12px; "></span> Stationed for > 15Min
                        </li>
                        <li>
                            <span class="greyCls"></span> Offline Vehicles
                        </li>
                    </ul>
                </div>
                <div class="custom-layer-toggle" (click)="showLayerCard = !showLayerCard">
                    <i class="fas fa-layer-group"></i>
                </div>
                <div class="layer-selection-card" *ngIf="showLayerCard">
                    <div class="layer-card-header">
                        <span>Select Map Layer</span>
                        <i class="fas fa-times close-icon" (click)="showLayerCard = false"></i>
                    </div>
                    <div class="layer-options">
                        <button class="layer-btn" [class.active]="selectedLayer === 'street'"
                            (click)="setMapLayer('street')">Street View</button>
                        <button class="layer-btn" [class.active]="selectedLayer === 'osm'"
                            (click)="setMapLayer('osm')">OSM View</button>
                        <button class="layer-btn" [class.active]="selectedLayer === 'sat'"
                            (click)="setMapLayer('sat')">Satellite View</button>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!showMapOnly" class="tables-view-col">
        <div class="alerts-section">
            <div class="section-header">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <span class="section-title">Alerts ({{alertsData.length}})</span>
                    </div>
                    <!-- <div class="col-lg-4 col-md-4">
                        <input nz-input [(ngModel)]="searchText" placeholder="Search..." class="search-bar" />
                    </div> -->
                </div>
            </div>
            <div class="row bg-wp">
                <div class="ds-card grid tbl">
                    <app-data-grid id="gridContainer"
                    style="width: 100%;"
                    [dataSource]="alertsData"
                    [legacyColumns]="columnDefs"
                    [searchPanel]="true"
                    [filterRow]="false"
                    [filterPanel]="false"
                    [groupPanel]="false"
                    [columnChooser]="false"
                    [allowExport]="true"
                    exportFileName="Alerts Data"
                    [pageSize]="10"
                    [allowedPageSizes]="[10, 20, 30, 50]"
                    [showPageSizeSelector]="true"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [wordWrapEnabled]="true">
                        
                        
                    <app-grid-column [showInColumnChooser]="false" [visible]="true" [width]="150" caption="Reason"
                            cellTemplate="reasonCellTemplate"></app-grid-column>
                    <ng-template appGridCell="reasonCellTemplate" let-data="cell"><div>
                                <ng-container *ngIf="data.data.sbmtd_in == 1; else reasonSelect">
                                    <span>{{data.data.alrt_sbmtd_rsn}}</span>
                                </ng-container>
                                <ng-template #reasonSelect>
                                    <ng-container *ngIf="data.data.alrt_rsn_cd === 'OTHR'; else normalReasonSelect">
                                        <input nz-input [(ngModel)]="data.data.alrt_rsn_tx" placeholder="Enter Comment"
                                            style="width: 100%;" />
                                    </ng-container>
                                    <ng-template #normalReasonSelect>
                                        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Reason"
                                            style="width: 100%;" [(ngModel)]="data.data.alrt_rsn_id"
                                            (ngModelChange)="onReasonSelect(data.data, $event)">
                                            <nz-option [nzLabel]="c.alrt_rsn_nm" [nzValue]="c.alrt_rsn_id"
                                                *ngFor="let c of data.data.alrt_rsns">
                                            </nz-option>
                                        </nz-select>
                                    </ng-template>
                                </ng-template>
                            </div></ng-template>

                        
                    <app-grid-column [width]="120" caption="Comment" cellTemplate="rsnCellTemplate" [visible]="true"></app-grid-column>
                    <ng-template appGridCell="rsnCellTemplate" let-data="cell"><div>
                                <ng-container *ngIf="data.data.sbmtd_in == 1 && data.data.sbmt_alrt_rsn_tx != null">
                                    <div>
                                        {{data.data.sbmt_alrt_rsn_tx}}
                                    </div>
                                </ng-container>
                            </div></ng-template>

                        
                    <app-grid-column [showInColumnChooser]="false" [visible]="true" [width]="20" caption="Submit"
                            cellTemplate="submitCellTemplate"></app-grid-column>
                    <ng-template appGridCell="submitCellTemplate" let-data="cell"><div>
                                <ng-container *ngIf="data.data.sbmtd_in == 1">
                                    <div class="tblEdtBtn">
                                        <i nz-icon nzType="check-circle" nzTheme="outline" style="color:#52c41a;"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="data.data.sbmtd_in != 1">
                                    <div class="tblEdtBtn"
                                        (click)="perms.canUpdate() && changeReason(data)"
                                        [style.opacity]="perms.canUpdate() ? 1 : 0.4"
                                        [title]="perms.canUpdate() ? 'Submit reason' : 'You do not have permission to update'">
                                        <i nz-icon nzType="check-circle" nzTheme="outline"
                                            [style.color]="perms.canUpdate() ? '#1a80c4' : '#9aa1a8'"
                                            [style.cursor]="perms.canUpdate() ? 'pointer' : 'not-allowed'"></i>
                                    </div>
                                </ng-container>
                            </div></ng-template>


                    </app-data-grid>
                </div>
            </div>
        </div>
        <nz-tabs>
            <nz-tab nzTitle="Started Vehicles">
                <div class="started-vehicles-section">
                    <div class="section-header">Started Vehicles {{startedVehiclesData.length}}</div>
                    <app-data-grid class="vehicles-grid"
                    style="width: 100%;"
                    [dataSource]="startedVehiclesData"
                    [legacyColumns]="strtdVehiclesDatacolumnDefs"
                    [searchPanel]="true"
                    [filterRow]="false"
                    [filterPanel]="false"
                    [groupPanel]="false"
                    [columnChooser]="false"
                    [allowExport]="true"
                    exportFileName="Started Vehicles Data"
                    [pageSize]="10"
                    [allowedPageSizes]="[10, 20, 30, 50]"
                    [showPageSizeSelector]="true"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [wordWrapEnabled]="true">
                        
                    </app-data-grid>
                </div>
            </nz-tab>
            <nz-tab nzTitle="Unauthorized/Not Mapped">
                <div class="unauthorized-movement-section">
                    <div class="section-header">Unauthorized/Not Mapped Vehicles {{unAuthVehData.length}}</div>
                    <app-data-grid class="vehicles-grid"
                    style="width: 100%;"
                    [dataSource]="unAuthVehData"
                    [legacyColumns]="unAuthcolumnDefs"
                    [searchPanel]="true"
                    [filterRow]="false"
                    [filterPanel]="false"
                    [groupPanel]="false"
                    [columnChooser]="false"
                    [allowExport]="true"
                    exportFileName="Unauthorized Alerts Data"
                    [pageSize]="10"
                    [allowedPageSizes]="[10, 20, 30, 50]"
                    [showPageSizeSelector]="true"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [wordWrapEnabled]="true">
                        
                        
                    <app-grid-column [showInColumnChooser]="false" [visible]="true" [width]="150" caption="Reason"
                            cellTemplate="reasonCellTemplate"></app-grid-column>
                    <ng-template appGridCell="reasonCellTemplate" let-data="cell"><div>
                                <ng-container *ngIf="data.data.sbmtd_in == 1; else reasonSelect">
                                    <span>{{data.data.alrt_sbmtd_rsn}}</span>
                                </ng-container>
                                <ng-template #reasonSelect>
                                    <ng-container *ngIf="data.data.alrt_rsn_cd === 'OTHR'; else normalReasonSelect">
                                        <input nz-input [(ngModel)]="data.data.alrt_rsn_tx" placeholder="Enter Comment"
                                            style="width: 100%;" />
                                    </ng-container>
                                    <ng-template #normalReasonSelect>
                                        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Reason"
                                            style="width: 100%;" [(ngModel)]="data.data.alrt_rsn_id"
                                            (ngModelChange)="onReasonSelect(data.data, $event)">
                                            <nz-option [nzLabel]="c.alrt_rsn_nm" [nzValue]="c.alrt_rsn_id"
                                                *ngFor="let c of data.data.alrt_rsns">
                                            </nz-option>
                                        </nz-select>
                                    </ng-template>
                                </ng-template>
                            </div></ng-template>

                        
                    <app-grid-column [width]="120" caption="Comment" cellTemplate="rsnCellTemplate" [visible]="true"></app-grid-column>
                    <ng-template appGridCell="rsnCellTemplate" let-data="cell"><div>
                                <ng-container *ngIf="data.data.sbmtd_in == 1 && data.data.sbmt_alrt_rsn_tx != null">
                                    <div>
                                        {{data.data.sbmt_alrt_rsn_tx}}
                                    </div>
                                </ng-container>
                            </div></ng-template>

                        
                    <app-grid-column [showInColumnChooser]="false" [visible]="true" [width]="20" caption="Submit"
                            cellTemplate="submitCellTemplate"></app-grid-column>
                    <ng-template appGridCell="submitCellTemplate" let-data="cell"><div>
                                <ng-container *ngIf="data.data.sbmtd_in == 1">
                                    <div class="tblEdtBtn">
                                        <i nz-icon nzType="check-circle" nzTheme="outline" style="color:#52c41a;"></i>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="data.data.sbmtd_in != 1">
                                    <div class="tblEdtBtn"
                                        (click)="perms.canUpdate() && changeReason(data)"
                                        [style.opacity]="perms.canUpdate() ? 1 : 0.4"
                                        [title]="perms.canUpdate() ? 'Submit reason' : 'You do not have permission to update'">
                                        <i nz-icon nzType="check-circle" nzTheme="outline"
                                            [style.color]="perms.canUpdate() ? '#1a80c4' : '#9aa1a8'"
                                            [style.cursor]="perms.canUpdate() ? 'pointer' : 'not-allowed'"></i>
                                    </div>
                                </ng-container>
                            </div></ng-template>

                    </app-data-grid>
                </div>
            </nz-tab>
            <nz-tab nzTitle="Other Vehicles ">
                <div class="other-vehicles-section">
                    <div class="section-header">Other Vehicles {{othrVehData.length}}</div>
                    <app-data-grid class="vehicles-grid"
                    style="width: 100%;"
                    [dataSource]="othrVehData"
                    [legacyColumns]="othrVehDatacolumnDefs"
                    [searchPanel]="true"
                    [filterRow]="false"
                    [filterPanel]="false"
                    [groupPanel]="false"
                    [columnChooser]="false"
                    [allowExport]="true"
                    exportFileName="Alerts Data"
                    [pageSize]="10"
                    [allowedPageSizes]="[10, 20, 30, 50]"
                    [showPageSizeSelector]="true"
                    [rowAlternationEnabled]="true"
                    [showBorders]="true"
                    [wordWrapEnabled]="true">
                        
                    </app-data-grid>
                </div>
            </nz-tab>
        </nz-tabs>
    </div>
</div>